import { ComponentType, ReactNode } from 'react'
import { Outlet } from 'react-router-dom'

import { FinancialWorkspace } from 'modules/finance/components/FinancialWorkspace'
import { ResponsivePageWithPanel } from 'modules/finance/components/FinancialWorkspace/components/ResponsivePageWithPanel'
import { useFinancialWorkspaceAvailabilities } from 'modules/finance/components/FinancialWorkspace/hooks/useFinancialWorkspaceAvailabilities'
import {
  InsightTableGroupBy,
  InsightTableType
} from 'modules/finance/components/FinancialWorkspace/types/table'
import { AvailabilitiesProvider } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/Providers/Availabilities'
import { CustomFiltersProvider } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/Providers/CustomFilters'
import { PermissionsProvider } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/Providers/PermissionsProvider'

import { useFilters } from './components/Filters/useFilters'
import { Header } from './components/Header'
import { PayrollLanding } from './components/Landing'
import { useTableProps } from './components/Table/props'
import { PayrollChart } from './components/chart'

const FinancialWorkspacePayroll = ({
  authorized,
  seePayrollLanding
}: {
  authorized: boolean
  useCompensation?: boolean
  seePayrollLanding: boolean
}) => {
  const availabilities = useFinancialWorkspaceAvailabilities()
  const tableProps = useTableProps()

  const CustomProvider: ComponentType<{ children: ReactNode }> = ({ children }) => (
    <PermissionsProvider>
      <AvailabilitiesProvider>
        <CustomFiltersProvider>{children}</CustomFiltersProvider>
      </AvailabilitiesProvider>
    </PermissionsProvider>
  )

  return (
    <ResponsivePageWithPanel
      authorized={authorized}
      showHeader={false}
      variant="fullscreen"
      panelTitle=""
    >
      <FinancialWorkspace
        tableProps={tableProps}
        chart={<PayrollChart />}
        dataProvider={CustomProvider}
        useAdditionalFilters={useFilters}
        insightTableType={InsightTableType.Payroll}
        defaultGroupBy={InsightTableGroupBy.LineItem}
        header={<Header availabilities={availabilities} />}
        renderLandingBanner={
          seePayrollLanding ? () => <PayrollLanding availabilities={availabilities} /> : undefined
        }
      />
      <Outlet context={{ canSeeFinanceWorkspace: authorized }} />
    </ResponsivePageWithPanel>
  )
}

export default FinancialWorkspacePayroll
